import ElectricalForm from './ElectricalForm';
import ElectricalPDF from './ElectricalPDF';
import schema from './schema';
import validator from './validator';
import defaultData from './defaultData';
import { transformForPDF } from './transform';
import templates from './templates';

// ✅ STANDARDIZED EXPORT NAMES
export default {
  Form: ElectricalForm,       // Always export as "Form"
  PDF: ElectricalPDF,         // Always export as "PDF"
  schema,
  validator,
  defaultData,
  transform: transformForPDF, // Map named export to "transform"
  templates
};